// eslint-disable-next-line import/prefer-default-export
export const createAPIQuery = <APIFn, KeyFn>(apiFn: APIFn, keyFn: KeyFn) => {
  Object.assign(apiFn, { key: keyFn });
  return apiFn as APIFn & { key: KeyFn };
};
